import React, { useRef, useEffect } from 'react';
import styles from './BotoneraSolapas.module.css';

const BotoneraSolapas = (props) => {
  const solapas = props.solapas;
  const selected = props.selected;
  const containerRef = useRef(null);

  const onSolapaElegida = (event) => {
    props.onSolapaElegida(event.target.value);
  };

  // Auto-scroll a la solapa seleccionada en mobile
  useEffect(() => {
    if (containerRef.current && selected) {
      // Esperar a que el DOM esté actualizado
      setTimeout(() => {
        const selectedElement = containerRef.current?.querySelector(
          `input[value="${selected}"]`
        )?.parentElement;
        if (selectedElement && window.innerWidth < 768) {
          // Scroll al centro de la solapa seleccionada
          const container = containerRef.current;
          const elementPosition = selectedElement.offsetLeft + selectedElement.offsetWidth / 2;
          const containerCenter = container.offsetWidth / 2;
          container.scrollLeft = elementPosition - containerCenter;
        }
      }, 0);
    }
  }, [selected]);

  return (
    <React.Fragment>
      {solapas && (
        <div className={`${styles.cuadroSolapas}`} ref={containerRef} role="tablist">
          {solapas.map((solapa, index) => (
            <React.Fragment key={index}>
              {solapa.visible && (
                <label
                  key={index}
                  className={`${styles.solapa} ${solapa.nombre === selected ? styles.selected : ''}`}
                  role="tab"
                  aria-selected={solapa.nombre === selected?.nombre}
                  aria-label={solapa.nombre}
                >
                  <input
                    type="radio"
                    key={index}
                    value={solapa.nombre}
                    checked={solapa === selected}
                    onChange={onSolapaElegida}
                    aria-label={`Solapa ${solapa.nombre}`}
                  />
                  {solapa.nombre}
                </label>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default BotoneraSolapas;
